// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1pa1n","iconWithCounter":"styles_iconWithCounter__w_oXb","counterForLabel":"styles_counterForLabel__XHaAO","counterForIcon":"styles_counterForIcon__d_Q_q"};